import { render } from "./ExportHistory.vue?vue&type=template&id=02236450"
import script from "./ExportHistory.vue?vue&type=script&lang=js"
export * from "./ExportHistory.vue?vue&type=script&lang=js"

import "./ExportHistory.vue?vue&type=style&index=0&id=02236450&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__